import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

/**
 * Resolve protocol submit control (Figma `resolve-submit` / `Button-Green-Sm`).
 * Idle: single right-aligned green Submit. Submitted: check + “Submitted” + timestamp.
 */
@Component({
  selector: 'eventq-resolve-submit',
  imports: [MatIcon],
  templateUrl: './resolve-submit.html',
  styleUrl: './resolve-submit.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'eventq-resolve-submit',
    '[attr.data-submitted]': 'submitted() ? "true" : "false"',
    '[attr.data-disabled]': 'submitDisabled() ? "true" : "false"',
  },
})
export class EventqResolveSubmit {
  readonly submitted = input(false);
  readonly submittedAt = input<string | undefined>(undefined);
  /** When true, Submit is non-interactive (incomplete form / locked / skipped). */
  readonly submitDisabled = input(false);
  readonly label = input('Submit');

  readonly submit = output<void>();

  onSubmit(): void {
    if (this.submitted() || this.submitDisabled()) {
      return;
    }
    this.submit.emit();
  }
}
